import { noop } from 'util/functions'

import { Form, FormProps } from './Form'

/**
 * Form usado apenas pelo estado dos campos, sem submissão (filtros, buscas e afins): o onSubmit é um noop.
 *
 * Mantido como wrapper separado em vez de uma prop em Form (ex.: submitless) para preservar o contrato de tipos:
 * em Form o onSubmit é obrigatório, e aqui ele nem pode ser passado. Uma prop tornaria onSubmit opcional,
 * abrindo combinações inválidas, ou exigiria uma union discriminada em FormProps, que é bastante estendido.
 */
export function SubmitlessForm<FormValues extends object = any>(
  props: Readonly<Omit<FormProps<FormValues>, 'onSubmit'>>
) {
  return <Form<FormValues> {...props} onSubmit={noop} />
}
